import mockResponses from "./mockResponses";

const useMockData = false;
/** Which set of networks the mock hands back. Keys: mockResponses/additionalGivingNetworks.js */
const givingNetworksScenario = "parent";

// 🚨🚨🚨 👇 Don't change this 👇 🚨🚨🚨
const _useMockData_PROTECTED =
  process.env.NODE_ENV === "development" ? useMockData : false;
const _givingNetworksScenario_PROTECTED =
  process.env.NODE_ENV === "development" ? givingNetworksScenario : "none";
// 🚨🚨🚨 👆 Don't change this 👆 🚨🚨🚨

const getAdditionalGivingNetworks = () =>
  mockResponses.additionalGivingNetworksByScenario[
    _givingNetworksScenario_PROTECTED
  ];

export const mockData = {
  shouldMock: _useMockData_PROTECTED,
  getAdditionalGivingNetworks,
};
